import { render, staticRenderFns } from "./frais-de-gestion.vue?vue&type=template&id=c0b56dd6"
import script from "./frais-de-gestion.vue?vue&type=script&lang=ts"
export * from "./frais-de-gestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports